import * as React from "react";
import { Modal, Button, Tabs } from "antd";
import { ISection } from "../../../model/formconfiguration/Section";
import FormConfigSectionQualifier, {
  IFormConfigSectionQualifier
} from "../../../model/formconfiguration/FormConfigSectionQualifier";

const { TabPane } = Tabs;

const SELECT_EXISTING_QUALIFIER_TAB_KEY = "selectExistingQualifier";
const NEW_QUALIFIER_TAB_KEY = "newQualifier";

export interface State {
  selectedTabKey: string;
}

export interface Props {
  translate: any;
  visible?: boolean;
  onCancel?: any;
  CreateQualifierForm: any;
  SelectExistingQualifierForm: any;
  createFormConfigSectionQualifier(
    parentFormSection: ISection,
    formConfigSectionQualifier: IFormConfigSectionQualifier
  ): any;
  qualifiers?: any;
  parentFormSection: ISection;
}

export default class AddQualifierModal extends React.Component<Props, State> {
  private existingQualifierFormSubmitHandler: any;
  private newQualifierFormSubmitHandler: any;

  constructor(props) {
    super(props);
    this.state = {
      selectedTabKey: SELECT_EXISTING_QUALIFIER_TAB_KEY
    };

    this.onSubmit = this.onSubmit.bind(this);

    this.registerExistingQualifierFormSubmitHandler = this.registerExistingQualifierFormSubmitHandler.bind(
      this
    );
    this.registerNewQualifierFormSubmitHandler = this.registerNewQualifierFormSubmitHandler.bind(
      this
    );
  }

  registerExistingQualifierFormSubmitHandler(registrationHandler) {
    this.existingQualifierFormSubmitHandler = registrationHandler;
  }

  registerNewQualifierFormSubmitHandler(registrationHandler) {
    this.newQualifierFormSubmitHandler = registrationHandler;
  }

  private onSubmit(e) {
    const {
      createFormConfigSectionQualifier,
      onCancel,
      parentFormSection
    } = this.props;
    const { selectedTabKey } = this.state;

    if (
      this.existingQualifierFormSubmitHandler ||
      this.newQualifierFormSubmitHandler
    ) {
      let newData;

      switch (selectedTabKey) {
        case SELECT_EXISTING_QUALIFIER_TAB_KEY:
          newData = this.existingQualifierFormSubmitHandler(e);
          if (newData) {
            createFormConfigSectionQualifier(
              parentFormSection,
              FormConfigSectionQualifier(newData)
            );
            onCancel();
          }
          break;
        case NEW_QUALIFIER_TAB_KEY:
          newData = this.newQualifierFormSubmitHandler(e);
          if (newData) {
            createFormConfigSectionQualifier(
              parentFormSection,
              FormConfigSectionQualifier(newData)
            );
            onCancel();
          }
          break;
      }
    }
  }

  render() {
    const {
      translate,
      visible,
      onCancel,
      CreateQualifierForm,
      SelectExistingQualifierForm,
      qualifiers
    } = this.props;

    return (
      <div onClick={(e) => e.stopPropagation()}>
        <Modal
          title={translate("create_qualifier_modal.title")}
          visible={visible}
          onCancel={onCancel}
          maskClosable={false}
          footer={[
            <Button key="back" onClick={onCancel}>
              {translate("modal_functions.insert_modal.cancel")}
            </Button>,
            <Button key="submit" type="danger" onClick={this.onSubmit}>
              {translate("modal_functions.insert_modal.add")}
            </Button>
          ]}
        >
          <Tabs
            defaultActiveKey={SELECT_EXISTING_QUALIFIER_TAB_KEY}
            onChange={(activeKey) =>
              this.setState({ selectedTabKey: activeKey })
            }
          >
            <TabPane
              tab={translate(
                "create_qualifier_modal.add_existing_qualifier_tab.tab_name"
              )}
              key="1"
            >
              <SelectExistingQualifierForm
                translate={translate}
                registerFormSubmitEventHandler={
                  this.registerExistingQualifierFormSubmitHandler
                }
                qualifiers={qualifiers}
              />
            </TabPane>
            <TabPane
              tab={translate(
                "create_qualifier_modal.add_new_qualifier_tab.tab_name"
              )}
              key={NEW_QUALIFIER_TAB_KEY}
            >
              <CreateQualifierForm
                translate={translate}
                registerFormSubmitEventHandler={
                  this.registerNewQualifierFormSubmitHandler
                }
              />
            </TabPane>
          </Tabs>
        </Modal>
      </div>
    );
  }
}
